
import React from 'react';
import { IconButton } from 'office-ui-fabric-react/lib/Button';
import { useDispatch } from 'react-redux';

import ToolButton from '../common/ToolButton';
import buttonCommandClick from './buttonCommandClick';

const ButtonCommandZoomIn = (props) => {

    const dispatch = useDispatch();
    const onClick = () => {
        buttonCommandClick(dispatch, 'ZOOM_IN');
    }

    return (
        <IconButton
            className={ToolButton.TOOL_STYLE}
            iconProps={ToolButton.getIcon('Add')}
            title="Přiblížit"
            onClick={onClick}
        />
    );
}

export default ButtonCommandZoomIn;
